import {until} from 'lit-html/directives/until';
import {wrapUnsafeHtml} from '@modules/wrap-unsafe-html';

export default (values, visibleItems, html, i18n) => {
  let moreHtml = '';
  let moreText = '';

  if (Array.isArray(values) === false) {
    return;
  }

  if (values.length > visibleItems) {
    const numMoreItems = values.length - visibleItems;
    moreText = html`${until(wrapUnsafeHtml(i18n._r(i18n.__('<tt-05a+ZYQT>', '+ %r1% more'), numMoreItems)))}`;
    moreHtml = html`<strong class="more">${moreText}</strong>`;
  }

  const renderedItems = values.slice(0, visibleItems).map((item) => { return item.name; }).join(', ');
  return html`<div class="text-truncate" title="${renderedItems}">${renderedItems}</div>${moreHtml}`;
};
